import { IWidgetsMarkup } from '../index';
import { IWidgetMarkupUnderMapFetched } from './underMap';

export function widgetMarkupReducer(state: IWidgetsMarkup, action: IWidgetMarkupUnderMapFetched): IWidgetsMarkup {
  switch (action.type) {
    case 'IWidgetMarkupUnderMapFetched':
      return {
        ...state,
        underMapMarkup: action.payload,
      };
    default:
      return state || {};
  }
}
